import React from "react";
import { Link } from "gatsby";

const TCPACopy = () => (
    <>
        By submitting, I agree to the{" "}
        <Link to="/terms/" target="terms">
            terms of use
        </Link>{" "}
        to permit autodialed texts and calls as described.
    </>
);

export default TCPACopy;
